<template>
  <div>
    <slot v-if="ready"></slot>
  </div>
</template>

<script>
import { ShaderCubeChrome } from '../../Reusable/ShaderCubeChrome'
import { CubeCam } from '../../Reusable/CubeCam'
import { Color } from 'three'
export default {
  props: {
    enable: {
      default () {
        return []
      }
    }
  },
  data () {
    return {
      ready: false,
      chroma: false
    }
  },
  mixins: [
    require('../../Reusable/O3DG2').O3DG2
  ],
  mounted () {
    if (this.enable.includes('chroma')) {
      this.chroma = new ShaderCubeChrome({
        renderer: this.ctx.renderer,
        loop: this.onLoop,
        res: 32,
        color: new Color('#ffffff')
      })
    }
    if (this.enable.includes('cubeCam')) {
      this.cubeCam = new CubeCam({
        renderer: this.ctx.renderer,
        loop: this.ctx.onLoop,
        res: 128,
        clean: this.onClean,
        camera: this.ctx.camera
      })
    }

    this.ready = true
  }
}
</script>

<style>

</style>